module.exports = __webpack_public_path__ + "static/media/HL15.b9e7d3ce.jpg";